import React from "react";
import { connect } from "react-redux";
import { Field } from "formik";
import axios from "axios";

import { override, remove } from "../redux/actions/itemsAction";
import Modal from "../../../modal";
import CheckBox from "../../../DataEntry/CheckBox";
import Radio from "../../../DataEntry/Radio";
import TextArea from "../../../DataEntry/TextArea";
import PopConfirm from "../../../modal/PopConfirm";

class Table extends React.Component<any, any> {
  state = {
    message: "",
    selectedItem: null,
    tags: [],
  };

  handleRemoveItem = (item: any) => {
    if (!item.wrong_item) return;

    const { remove } = this.props;
    remove(item);
  };

  handleAddTags = async () => {
    const { client, formik, received, store } = this.props;
    const { tags, type } = formik.values;
    let epcs = tags.replaceAll(" ", "").split(/[\n,]+/);
    if (type === "serial_number") {
      const { data } = await axios.get(
        `/${client}/${store}/api/v1/epc_states/epc_ids`,
        { params: { assets: epcs } },
      );
      epcs = data.epcs;
    }
    epcs = epcs.map((epc: string) => ({ EPC: epc }));
    await received({ epcs, manual: true });
    $("#manual-modal").modal("hide");
  };

  handleAddOverride = () => {
    const { formik, override } = this.props;
    const { selectedItem } = this.state;
    const { values } = formik;

    override(selectedItem, true, values.override_reason);

    $("#override-modal").modal("hide");
  };

  warningMessage = (item: any) => {
    if (item.wrong_item)
      return "The quantity read from the RFID labels is for an item that is not part of the sales order (SO).";

    if (item.ordered_qty > item.read_qty)
      return "The quantity read from the RFID labels is less than the quantity ordered in the sales order (SO).";

    if (item.ordered_qty < item.read_qty)
      return "The quantity read from the RFID labels exceeds the quantity ordered in the sales order (SO).";
  };

  // Modal

  showManualModal = () => {
    const { formik, viewOnly } = this.props;
    if (viewOnly) return;

    formik.setFieldValue("tags", "");
    $("#manual-modal").modal("show");
  };

  showTagModal = (item: any) =>
    this.setState({ tags: item.tags }, () => $("#tags-modal").modal("show"));

  showOverrideModal = (item: any) => {
    const { formik, override } = this.props;
    formik.setFieldValue("override_reason", "");

    if (item.override) {
      override(item, false, "");
    } else {
      if (item.wrong_item) {
      }
      this.setState(
        { selectedItem: item, message: this.warningMessage(item) },
        () => $("#override-modal").modal("show"),
      );
    }
  };

  // Renders

  renderTagsQuantity = () => {
    const { items } = this.props;
    return (
      items.reduce(
        (total: number, { tags }: any) => total + tags?.length || 0,
        0,
      ) || 0
    );
  };

  renderStatus = (item: any) => {
    if (item.wrong_item)
      return <div className="table-status danger-status"> Wrong Item </div>;
    if (!item.tags?.length)
      return <div className="table-status warning-status"> Pending </div>;
    if (item.read_qty === item.ordered_qty)
      return <div className="table-status success-status"> Match QTY </div>;

    return (
      <div className="table-status low-warning-status">
        {item.read_qty < item.ordered_qty ? "Less" : "More"} QTY
      </div>
    );
  };

  downloadCSV = (item: any) => {
    const data = ["Serial#, EPC"]
      .concat(
        item.tags.map((tag: any) => [tag.asset_id, tag.epc_id].join(", ")),
      )
      .join("\r\n");
    const csvData = new Blob([data], { type: "text/csv" });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement("a");
    link.href = csvURL;
    link.download = `${item.item_number}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    const { client, items, store, viewOnly } = this.props;
    const { message, tags } = this.state;

    return (
      <>
        <div className="row">
          <div className="table-responsive col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <table className="table sn-table table-striped table-hover">
              <thead>
                <tr className="center-content">
                  <th className="text-left">Item # & Description</th>
                  <th>UOM</th>
                  <th>Expected QTY</th>
                  <th># of Tags</th>
                  <th>Read QTY</th>
                  <th>Status</th>
                  <th>Validation</th>
                  <th>Override</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item: any) => (
                  <tr className="center-content" key={item.item_number}>
                    <td className="text-left">
                      {[
                        item.item_number,
                        item.item?.description,
                        item.item?.sku,
                      ].join(" ")}
                      &nbsp;
                      {item.tags && (
                        <i
                          className="fa fa-tag text-info pointer"
                          onClick={() => this.showTagModal(item)}
                        />
                      )}
                    </td>
                    <td>{item.item?.base_unit_of_measure}</td>
                    <td>{item.ordered_qty}</td>
                    <td className="bold">
                      {item.tags?.length ? (
                        <PopConfirm
                          text="This will download CSV."
                          onConfirm={() => this.downloadCSV(item)}
                        >
                          <a className="pointer">{item.tags.length}</a>
                        </PopConfirm>
                      ) : (
                        0
                      )}
                    </td>
                    <td className="bold">{item.read_qty || 0}</td>
                    <td>{this.renderStatus(item)}</td>
                    <td>
                      <i
                        className={`fa fa-${item.valid || item.override ? "check text-success" : "close text-danger"}`}
                      />
                    </td>
                    <td className="sn-form">
                      <Field
                        className="form-control checkbox-field"
                        component={CheckBox}
                        checked={item.override || false}
                        disabled={viewOnly || item.valid}
                        name={`override.${item.id}`}
                        onClick={() => this.showOverrideModal(item)}
                      />
                    </td>
                    <td className="sn-icons">
                      {viewOnly || !item.wrong_item ? (
                        <a className="fa fa-minus-circle disabled" />
                      ) : (
                        <PopConfirm
                          text="This will remove wrong item from the list."
                          onConfirm={() => this.handleRemoveItem(item)}
                        >
                          <a className="fa fa-minus-circle delete-icon pointer" />
                        </PopConfirm>
                      )}
                    </td>
                  </tr>
                ))}
                <tr className="center-content">
                  <td colSpan={3}></td>
                  <td className="bold"> {this.renderTagsQuantity()} </td>
                  <td colSpan={5}></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 text-right">
            {/* <button type="button" className="sn-btn sn-btn-sm sn-btn-green">
              Override BOL
            </button>
            <br /> */}
            <button
              type="button"
              className="sn-btn sn-btn-sm sn-btn-teal"
              disabled={viewOnly}
              onClick={this.showManualModal}
            >
              Manual ADD
            </button>
          </div>
        </div>

        <Modal id="tags-modal" title="Tag Details" size="md">
          {tags.map((tag: any, i: number) => [
            i > 0 && ", ",
            <a
              key={tag.id}
              href={`/${client}/${store}/item_details/${tag.id}`}
              target="blank"
            >
              {tag.asset_id}
            </a>,
          ])}
        </Modal>

        <Modal
          id="override-modal"
          title="Override Warning & Notification"
          size="md"
          button={
            <button
              type="button"
              className="sn-btn sn-btn-sm sn-btn-red"
              style={{ marginLeft: "5px" }}
              onClick={this.handleAddOverride}
            >
              Yes, Continue
            </button>
          }
        >
          <div className="row">
            <div className="col-xs-12 text-center">
              <i className="text-danger fa fa-warning fa-5x"></i>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              {message}&nbsp;Are you sure you want to continue?
            </div>
          </div>
          <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-xs-12">
              <label id="override_reason"> Reason: </label>
              <Field
                className="form-control"
                component={TextArea}
                name="override_reason"
                rows={3}
              />
              <br />
              <span className="text-danger"> Note: </span> <br />
              <span className="sn-small-text gray-text">
                An email will be sent to management to confirm this exception
                along with your confirmation to proceed.
              </span>
            </div>
          </div>
        </Modal>

        <Modal
          id="manual-modal"
          title="Add tags manually"
          size="md"
          button={
            <button
              type="button"
              className="sn-btn sn-btn-sm sn-btn-teal"
              style={{ marginLeft: "5px" }}
              onClick={this.handleAddTags}
            >
              Add
            </button>
          }
        >
          <div className="row">
            <div className="col-xs-12">
              <Field
                component={Radio}
                name="type"
                list={[
                  ["serial_number", "Serial Number"],
                  ["epc", "EPC"],
                ]}
                wrapper={{ style: { marginRight: "20px" } }}
              />
            </div>
            <div className="col-xs-12">
              <Field
                className="form-control"
                component={TextArea}
                name="tags"
                rows={4}
              />
              <span className="sn-small-text gray-text">
                Enter tags separated by comma or line break
              </span>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  items: state.items.data,
});

const mapDispatchToProps = {
  override,
  remove,
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);
